var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dv-scroll-board',{staticStyle:{"width":"100%","height":"230px","padding":"0 20px"},attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }